import React from 'react';

const ForgotPassword = () => {
  return (
    <div>
      <h2>Forgot Password</h2>
      <input type="email" placeholder="Enter your email" />
      <button>Reset Password</button>
    </div>
  );
};

export default ForgotPassword;

